import { render, staticRenderFns } from "./CardDetail.vue?vue&type=template&id=0f8db7a2&scoped=true&lang=pug&"
import script from "./CardDetail.vue?vue&type=script&lang=ts&"
export * from "./CardDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CardDetail.vue?vue&type=style&index=0&id=0f8db7a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8db7a2",
  null
  
)

export default component.exports